/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Onl_HostedInputs */

const en_vc_onl_hosted = /** @type {(inputs: Vc_Onl_HostedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Official open-source web build, hosted by this site. Not affiliated with ArtCraft.`)
};

const zh_vc_onl_hosted = /** @type {(inputs: Vc_Onl_HostedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`官方开源网页版，由本站托管，与 ArtCraft 官方无关。`)
};

/**
* | output |
* | --- |
* | "Official open-source web build, hosted by this site. Not affiliated with ArtCraft." |
*
* @param {Vc_Onl_HostedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_onl_hosted = /** @type {((inputs?: Vc_Onl_HostedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Onl_HostedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_onl_hosted(inputs)
	return zh_vc_onl_hosted(inputs)
});
export { vc_onl_hosted as "vc.onl.hosted" }